import { useParams } from "react-router-dom";

import {
  EmptyInsightsPage,
  InsightsPage,
} from "@/features/insights/insights-page";
import { useWorkGroupQuery } from "@/generated/graphql";

export function StudentInsights() {
  const { assessmentId = "" } = useParams();
  const { data } = useWorkGroupQuery({ variables: { assessmentId } });
  const group = data?.studentWorkGroup?.group;
  const workId = data?.studentWorkGroup?.work?.id;

  if (!group || !workId) return <EmptyInsightsPage />;

  return (
    <InsightsPage assessmentId={assessmentId} workId={workId} group={group} />
  );
}
